import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { getCMSPage } from '@mindfulchefuk/features/CMS/services/getCMSPage'
import { CMSPageRecipeOnboarding } from '@mindfulchefuk/features/CMS/interfaces'
import { STALE_10_MINS } from '@mindfulchefuk/constants'

export const useCMSPageRecipeOnboarding = <TData = CMSPageRecipeOnboarding>(
  options: UseQueryOptions<CMSPageRecipeOnboarding, unknown, TData> = {}
) => {
  return useQuery({
    queryKey: [`cms-page-recipe-onboarding`],
    queryFn: () =>
      getCMSPage('page-recipe-onboarding') as Promise<CMSPageRecipeOnboarding>,
    staleTime: STALE_10_MINS,
    ...options,
  })
}
